const Strings = {
  SUBJECT: {
    SE: 'Ämne',
    EN: 'Subject'
  },
  MESSAGE: {
    SE: 'Meddelande',
    EN: 'Message'
  },
  HOW_URGENT_IS_IT: {
    SE:
      'Hur akut är det? (På en skala från trasig glödlampa till pågående eldsvåda)',
    EN:
      'How urgent is it? (On a scale from broken light-bulb to an ongoing fire)'
  },
  WHERE_IS_THE_ERROR: {
    SE: 'Var är felet?',
    EN: 'Where is the error?'
  },
  NEW_ERROR_REPORT: {
    SE: 'Ny felrapport',
    EN: 'New error report'
  },
  MY_APARTMENT: {
    SE: 'Min lägenhet',
    EN: 'My apartment'
  },
  COMMON_AREA: {
    SE: 'Gemensamt utrymme',
    EN: 'Common area'
  },
  OUTDOORS: {
    SE: 'Utomhus',
    EN: 'Outdoors'
  },
  OTHER: {
    SE: 'Annat',
    EN: 'Other'
  },
  SEND: {
    SE: 'Skicka',
    EN: 'Send'
  },
  REPORT_AN_ERROR: {
    SE: 'Rapportera ett fel',
    EN: 'Report an error'
  },
  INFORMATION_ABOUT_REPORTING_AN_ERROR: {
    SE:
      'För att din felrapport ska kunna lösas så snabbt som möjligt så kan kontinuerlig kontakt mellan dig och din vaktmästare ske via chatten.',
    EN:
      'To solve your error report as soon as possible you can maintain a continuously contact with your janitor through this chat.'
  },
  INFORMATION_ABOUT_REPORTING_AN_ERROR_EMAIL: {
    SE:
      'Din felrapport skickas direkt till din vaktmästares email som sedan svarar till mailadressen som du har registrerat.',
    EN:
      'Your error report is send directly to your janitor\'s email which then will respond to the email address that you have registered.'
  },
  MISSING_SUBJECT: {
    SE: 'Ämne saknas',
    EN: 'Subject missing'
  },
  MISSING_SUBJECT_INFO: {
    SE: 'Var god skriv ett ämne och försök igen.',
    EN: 'Please enter a subject and try again.'
  },
  MISSING_MESSAGE: {
    SE: 'Meddelande saknas',
    EN: 'Message missing'
  },
  MISSING_MESSAGE_INFO: {
    SE: 'Var god skriv ett meddelande och försök igen.',
    EN: 'Please enter a message and try again.'
  },
  MISSING_LOCATION: {
    SE: 'Plats saknas',
    EN: 'Location missing'
  },
  MISSING_LOCATION_INFO: {
    SE: 'Var god välj en plats och försök igen.',
    EN: 'Please enter a location and try again.'
  },
  OK: {
    SE: 'Okej',
    EN: 'Okey'
  },
  ERROR_REPORT_SEND: {
    SE: 'Felrapport skickad',
    EN: 'Error report send'
  },
  ERROR_REPORT_SEND_INFO: {
    SE: 'Din felrapport har skickats.',
    EN: 'Your error report has been send.'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/errorReports/NewErrorReport/strings.js